// changes

const getThresholdValueMeningitis = (level) => {
  switch (level) {
    case 1:
      return {
        category: 'Minimal',
        threshold: '0-<20',
        color: '#E5FDF7',
        OutlineColor: '#2B9181',
      }
    case 2:
      return {
        category: 'Low',
        threshold: '20-<40',
        color: '#AAC9E4',
        OutlineColor: '#2D6EA3',
      }
    case 3:
      return {
         category: 'Medium',
        threshold: '40-<60',
        color: '#7796CC',
        OutlineColor: '#0E456B',
      }
    case 4:
      return {
         category: 'High',
        threshold: '60-<80',
        color: '#5163AE',
        OutlineColor: '#FFFFFF',
      }
    case 5:
      return {
        category: 'Very High',
        threshold: '80-<100',
        color: '#422C88',
        OutlineColor: '#FFFFFF',
      }

    default:
      return {
        category: 'No Data',
        threshold: '0',
        color: '#6D6F70',
        OutlineColor: '#6D6F70',
      }
  }
}

export default getThresholdValueMeningitis